import PageContainer from "component/ui/PageContainer";
import PageHeading from "component/ui/PageHeading";
import { useEffect, useState } from "react";
import profile from "../../assets/profile.png";
import Input from "component/ui/Input";
import { CARDS_ENUMS } from "helper/constant";
import SelectField from "component/ui/SelectField";
import { FaUser } from "react-icons/fa";
import SearchInput from "component/ui/SearchInput";
import { FiSearch } from "react-icons/fi";
import DateAndTimePicker from "component/ui/Datepicker";
import Textarea from "component/ui/Textarea";
import Button from "component/ui/Button";
import RadioButton from "component/ui/RadioButton";
import { convertDateTimeUtc, createUniqueId } from "helper/appConstant";
import { useDispatch, useSelector } from "react-redux";
import {
  getJoinRequestDetail,
  getVenueSelectedSportsList,
} from "store/slice/profile";
import {
  createRequestMatch,
  fetchClubOrAcademyList,
  updateRequestMatch,
} from "store/slice/booking";
import moment from "moment";
import { toast } from "react-toastify";
import FullPageLoader from "component/ui/fullPageLoader";
import { useNavigate, useParams } from "react-router-dom";
import { useLoginData } from "component/common/loginData";
import UserNameHeader from "component/UserNameHeader";

const ClubService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState();
  const userData = useLoginData();
  const { id } = useParams();
  const [selectedPlayer, setSelectedPlayer] = useState(false);
  const [formData, setFormData] = useState({
    venueName: userData?.name,
    cardReferenceType: "no",
    cardReferenceID: createUniqueId(CARDS_ENUMS?.SERVICE),
  });
  const { venueSelectedSportsData, userProfileData, joinRequestDetail } =
    useSelector((state) => state.profile);
  const { clubOrAcademyList } = useSelector((state) => state.booking);
  const [loader, setLoader] = useState(false);

  // fetch details
  useEffect(() => {
    if (id && id != "new") {
      setLoader(true);
      dispatch(getJoinRequestDetail(id, setLoader));
    }
  }, [id]);
  useEffect(() => {
    if (venueSelectedSportsData?.length == 0) {
      dispatch(getVenueSelectedSportsList());
    }
  }, []);

  //  set request match details data to state
  useEffect(() => {
    if (joinRequestDetail && id) {
      setFormData({
        ...joinRequestDetail,
        startDate: moment(joinRequestDetail?.startDate, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        ),
        coordinates: joinRequestDetail?.location?.coordinates,
        address: joinRequestDetail?.location?.address,
        // crewOrAssocianFullname: joinRequestDetail?.crewOrAssocianname,
        // crewOrAssocianname: joinRequestDetail?.crewId,
      });
    }
  }, [joinRequestDetail]);
  useEffect(() => {
    if (userProfileData) {
      fetchClubOrAcademy();
    }
  }, [userProfileData, formData?.category]);

  // fetch Crew/Association list
  const fetchClubOrAcademy = (searchQuery) => {
    const request = {
      language: "en",
      page: 1,
      perPage: 50,
      searchQuery: searchQuery || "",
      userCountry: null,
      sportName: formData?.category,
      productCountry: null,
      latitude: userProfileData?.data?.location?.coordinates[1],
      longitude: userProfileData?.data?.location?.coordinates[0],
    };
    dispatch(fetchClubOrAcademyList(request));
  };

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEventFields = () => {
    const requiredFields = [
      { key: "cardReferenceID", label: "card Reference ID" },
      { key: "category", label: "Game / Sport" },
      { key: "clubName", label: "Club/Academy Name" },
      { key: "mySkillLevel", label: "Skill level" },
      { key: "clubRequestCardDate", label: "Start date" },
      { key: "clubRequestCardTime", label: "Start time" },
      { key: "achievements", label: "My Achievements" },
    ];

    for (let field of requiredFields) {
      const value = formData?.[field.key];
      // empty / blank check
      if (
        value === undefined ||
        value === null ||
        (typeof value === "string" && !value.trim())
      ) {
        toast.error(`${field.label} is required`);
        return false;
      }
    }

    return true;
  };
  const handleSuccess = (status) => {
    if (status) {
      if (formData?.id) {
        navigate("/my-posting");
      } else {
        navigate("/dashboard");
      }
    }
    setLoader(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateEventFields()) return;
    setLoader(true);
    const request = {
      ...formData,
      startDateTimeUtc: convertDateTimeUtc(
        formData?.clubRequestCardDate,
        formData?.clubRequestCardTime
      ),
      address: userData?.location?.address,
      coordinates: userData?.location?.coordinates,
      location: userData?.location,
    };

    if (formData?.id) {
      const updateRequest = { ...request, joinCardId: formData?.id };
      dispatch(updateRequestMatch(updateRequest, handleSuccess));
    } else {
      dispatch(createRequestMatch(request, handleSuccess));
    }
  };
  return (
    <PageContainer>
      {loader && <FullPageLoader />}
      <div className="lg:max-w-5xl w-full mx-auto">
        <PageHeading
          title={"Request Match"}
          Subtitle={"Request to Join a Club"}
        />
      </div>
      <form className="lg:max-w-5xl w-full mx-auto lg:p-6 p-3 rounded-lg bg-white">
        <UserNameHeader />
        {!formData?.id && (
          <RadioButton
            label="Do you have a reference id"
            isRequired={true}
            options={["Yes", "No"]}
            selected={formData?.cardReferenceType}
            onChange={(e) => {
              if (e.target.value == "yes") {
                handleChange("cardReferenceID", "");
              } else {
                handleChange(
                  "cardReferenceID",
                  createUniqueId(CARDS_ENUMS?.JOIN)
                );
              }
              handleChange("cardReferenceType", e.target.value);
            }}
          />
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
          <Input
            label="Enter reference id"
            placeholder="Enter a valid reference id"
            required
            disabled={formData?.cardReferenceType == "no" || formData?.id}
            value={formData?.cardReferenceID}
            onChange={(e) => handleChange("cardReferenceID", e.target.value)}
            className="w-full"
          />

          <SelectField
            label="Select game or sport"
            value={formData?.category}
            onChange={(value) => handleChange("category", value)}
            isSport={true}
            options={venueSelectedSportsData}
            isRequired={true}
            placeholder="Select game or sport"
          />

          <SearchInput
            label="Club/Academy name"
            value={formData?.clubName}
            onFocus={() => setSelectedPlayer(true)}
            placeholder="Input username or @username"
            iconClass="top-[65%]"
            inputClass="!pl-4"
            isRequired
          />

          <div>
            <SelectField
              label="Your skill level"
              placeholder="Your skill level"
              value={formData?.mySkillLevel}
              onChange={(value) => handleChange("mySkillLevel", value)}
              options={["Beginner", "Intermediate", "Advanced"]}
              isRequired
            />
          </div>
        </div>

        <div className="mt-3">
          <label className="text-sm md:font-semibold font-medium text-gray-700 mb-1">
            Start Date & Time
            <span className="text-red-500 ml-1 font-bold">*</span>
          </label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <DateAndTimePicker
              showDate
              showTime={false}
              placeholderDate="Start Date"
              isRequired
              inputClassName="w-full"
              selectedDate={formData?.clubRequestCardDate}
              onDateChange={(date) =>
                handleChange(
                  "clubRequestCardDate",
                  date ? moment(date).format("YYYY-MM-DD") : ""
                )
              }
            />
            <Input
              type="time"
              isRequired
              value={formData?.clubRequestCardTime}
              onChange={(time) => handleChange("clubRequestCardTime", time)}
            />
          </div>
        </div>

        <>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-3">
            <Textarea
              id="message"
              label="My achievments"
              value={formData?.achievements}
              onChange={(e) => handleChange("achievements", e.target.value)}
              placeholder="Enter your achievements"
              rows={6}
              isRequired
            />

            <Textarea
              id="message"
              label="Description"
              value={formData?.description}
              onChange={(e) => handleChange("description", e.target.value)}
              placeholder="Enter description"
              rows={6}
            />
          </div>
        </>

        <div></div>

        <div className="flex justify-center mt-3">
          <Button onClick={handleSubmit}>Request a Match</Button>
        </div>
      </form>

      {selectedPlayer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fadeIn">
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-white">
                {" "}
                Club /Academy name
              </h3>
              <button
                onClick={() => setSelectedPlayer(null)}
                className="text-white text-xl hover:opacity-80"
              >
                ✕
              </button>
            </div>

            <div className="p-4">
              <SearchInput
                // onChange={(e) => fetchCrewAssociation(e.target.value)}
                placeholder="Search.."
                icon={FiSearch}
              />

              <div className="overflow-y-auto md:h-96 h-72 thin-scrollbar">
                {clubOrAcademyList?.map((item, index) => (
                  <div className="flex border-b pb-1 items-center justify-between my-3 pr-4 cursor-pointer">
                    <div
                      key={item?.clubId}
                      onClick={() => {
                        setFormData((formData) => ({
                          ...formData,
                          cluborAcademy: item?.clubId,
                          clubName: item?.clubName,
                        }));
                        setSelectedPlayer(null);
                      }}
                      className="flex items-center md:gap-5 gap-3"
                    >
                      <div className="md:w-10 md:h-10 w-7 h-7 font-semibold text-white rounded-full bg-highlight flex justify-center items-center">
                        {item?.clubName &&
                          item?.clubName?.charAt(0)?.toUpperCase()}
                      </div>
                      <p className="md:text-base text-sm">{item?.clubName}</p>
                    </div>
                    <FaUser
                      fill="#2bace2"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(`/player-details/${item?.id}`);
                      }}
                    />
                  </div>
                ))}
                <div
                  onClick={() => {
                    setFormData((formData) => ({
                      ...formData,
                      cluborAcademy: null,
                      clubName: "Not Listed",
                    }));
                    setSelectedPlayer(null);
                  }}
                  className="flex border-b pb-1 items-center justify-between my-3 pr-4 cursor-pointer"
                >
                  <div className="flex items-center md:gap-5 gap-3">
                    <div className="md:w-10 md:h-10 w-7 h-7 font-semibold text-white rounded-full bg-highlight flex justify-center items-center">
                      N
                    </div>
                    <p className="md:text-base text-sm">Not Listed</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </PageContainer>
  );
};

export default ClubService;
